import { Container } from "@mui/material";
import { useSelector } from 'react-redux';
import HeaderSession from "../../../utils/headerSession";
import RegisterAccess from "../../../utils/registerAccess";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import Loading from "../../../load/loading";
import FichaAdmin from "../fichaAdmin";


export default function PerfilAdmin() {
    const { id } = useParams()
    const user = useSelector(state => state.account.user);
    const [admin, setAdmin] = useState("");
    const [load, setLoad] = useState(true);

    useEffect(() => {
        if (id) {

            api.get(`/admin/${id}`)
                .then((response) => {
                    setLoad(false)
                    setAdmin(response.data.admin);
                })
                .catch((err) => console.log(err));
        } else {
            setLoad(false)
            setAdmin(user);
        }
    }, [id, user]);


    return (
        <Container style={{ marginBottom: 10 }}>

            <RegisterAccess page={'perfil admin'} />
            <HeaderSession title={id ? 'PERFIL' : 'MEU PERFIL'} />
            {/* {load ? <Loading /> : <InformacaoAdmin admin={admin} />} */}
            {load ? <Loading /> : <FichaAdmin admin={admin} local={'perfilAdmin'} />}

        </Container>
    )
}